export const NoDataFoundIllustration = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="156"
        height="97"
        viewBox="0 0 156 97"
        fill="none"
    >
        <path
            // eslint-disable-next-line max-len
            d="M55.4544 18.6143C55.4544 16.1739 55.4544 8.85248 55.4544 8.85248C55.4544 7.13447 54.0616 5.7417 52.3436 5.7417C50.6256 5.7417 49.2328 7.13447 49.2328 8.85248C49.2328 8.85248 49.2204 16.4743 49.2378 19.0165C49.2701 23.5722 53.4164 30.148 61.2134 31.2257V27.1053C58.6144 26.4714 55.4544 22.8249 55.4544 18.6143Z"
            fill="url(#paint0_linear_258_2388)"
        />
        <path
            d="M61.2852 29.0879C58.9179 28.792 54.9816 26.7578 53.3166 23.1504C51.6516 19.5429 52.2973 12.1581 52.2973 5.59473"
            stroke="white"
            strokeWidth="1.1211"
        />
        <circle
            opacity="0.3"
            cx="122.964"
            cy="33.7934"
            r="19.914"
            fill="url(#paint1_linear_258_2388)"
        />
        <path
            // eslint-disable-next-line max-len
            d="M54.4768 55.9919C54.4768 52.333 54.4768 41.359 54.4768 41.359C54.4768 38.7835 52.3882 36.6948 49.8126 36.6948C47.2371 36.6948 45.1484 38.7835 45.1484 41.359C45.1484 41.359 45.129 52.7858 45.1557 56.5932C45.2044 63.4215 47.7118 71.4329 60.7721 74.9238V67.5209C56.3416 65.9362 54.4768 62.3017 54.4768 55.9919Z"
            fill="url(#paint2_linear_258_2388)"
        />
        <path
            opacity="0.5"
            // eslint-disable-next-line max-len
            d="M79.7433 82.7417C70.7413 82.7417 62.1625 84.654 52.9575 96.5605H135.872C123.871 88.7397 115.055 72.3305 99.2839 75.2727C90.926 76.832 88.9254 82.7417 79.7433 82.7417Z"
            fill="url(#paint3_linear_258_2388)"
        />
        <path
            // eslint-disable-next-line max-len
            d="M83.3573 18.4834C80.7499 18.4834 78.6366 20.5966 78.6366 23.2041C78.6366 23.2041 78.6366 34.3071 78.6366 38.0109C78.6366 44.3961 76.7847 49.7937 74.3789 51.3076V57.1664C86.8084 54.2124 88.0155 45.5294 88.0666 38.6188C88.095 34.7644 88.0752 23.2041 88.0752 23.2041C88.0752 20.5966 85.9648 18.4834 83.3573 18.4834Z"
            fill="url(#paint4_linear_258_2388)"
        />
        <path
            d="M74.6509 54.0375C86.1078 50.1443 83.3455 34.3611 83.3455 18.3818"
            stroke="white"
            strokeWidth="1.1211"
        />
        <path
            d="M60.771 70.7163C57.522 69.7451 53.1275 67.9141 50.9303 63.1534C48.733 58.3927 49.5851 45.3592 49.5851 36.6978"
            stroke="white"
            strokeWidth="1.1211"
        />
        <path
            // eslint-disable-next-line max-len
            d="M61.4687 6.85639C61.5344 3.45605 64.3097 0.733887 67.7107 0.733887C71.1117 0.733887 73.887 3.45606 73.9527 6.8564L75.5386 88.9126H59.8828L61.4687 6.85639Z"
            fill="url(#paint5_linear_258_2388)"
        />
        <path
            // eslint-disable-next-line max-len
            d="M70.5916 88.9129L70.0079 6.69512C69.9837 3.28808 68.9621 0.560547 67.7101 0.560547C66.4582 0.560547 65.4366 3.28809 65.4124 6.69512L64.8286 88.9129"
            stroke="white"
            strokeWidth="1.1211"
        />
        <path
            // eslint-disable-next-line max-len
            d="M48.3706 81.349C36.1619 82.4495 31.1578 93.1907 18 96.5606L103.049 96.5606C79.9417 91.976 82.5471 84.0401 68.5433 86.8463C60.7652 88.4049 57.3799 80.537 48.3706 81.349Z"
            fill="url(#paint6_linear_258_2388)"
        />
        <circle
            opacity="0.3"
            cx="122.966"
            cy="33.793"
            r="13.7803"
            transform="rotate(-165 122.966 33.793)"
            fill="url(#paint7_linear_258_2388)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_258_2388"
                x1="58.2612"
                y1="26.7267"
                x2="49.2274"
                y2="6.79778"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#B1C7FF" />
                <stop
                    offset="1"
                    stopColor="#ECF1FF"
                />
            </linearGradient>
            <linearGradient
                id="paint1_linear_258_2388"
                x1="106.367"
                y1="53.7073"
                x2="138.112"
                y2="19.2383"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#769DFF" />
                <stop
                    offset="1"
                    stopColor="#E5EDFF"
                />
            </linearGradient>
            <linearGradient
                id="paint2_linear_258_2388"
                x1="59.3541"
                y1="66.5635"
                x2="47.5888"
                y2="39.4314"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#B1C7FF" />
                <stop
                    offset="1"
                    stopColor="#ECF1FF"
                />
            </linearGradient>
            <linearGradient
                id="paint3_linear_258_2388"
                x1="74.4353"
                y1="89.6298"
                x2="120.493"
                y2="90.6189"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D0DDFF" />
                <stop
                    offset="0.0001"
                    stopColor="#CCDBFF"
                />
                <stop
                    offset="1"
                    stopColor="#B0C6FF"
                />
            </linearGradient>
            <linearGradient
                id="paint4_linear_258_2388"
                x1="74.3789"
                y1="48.7621"
                x2="90.079"
                y2="26.623"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#B1C7FF" />
                <stop
                    offset="1"
                    stopColor="#ECF1FF"
                />
            </linearGradient>
            <linearGradient
                id="paint5_linear_258_2388"
                x1="75.5386"
                y1="53.8285"
                x2="59.8918"
                y2="53.4542"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#BACDFF" />
                <stop
                    offset="1"
                    stopColor="#F9FBFF"
                />
            </linearGradient>
            <linearGradient
                id="paint6_linear_258_2388"
                x1="40.8087"
                y1="96.5606"
                x2="75.512"
                y2="75.8612"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D7E3FF" />
                <stop
                    offset="1"
                    stopColor="#F4F7FF"
                />
            </linearGradient>
            <linearGradient
                id="paint7_linear_258_2388"
                x1="111.481"
                y1="47.5734"
                x2="133.448"
                y2="23.721"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#769DFF" />
                <stop
                    offset="1"
                    stopColor="#E5EDFF"
                />
            </linearGradient>
        </defs>
    </svg>
);
